import { DateTime } from 'luxon';

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result as string;
      // Remove the data URL prefix (e.g., "data:application/pdf;base64,")
      resolve(base64data.substr(base64data.indexOf(',') + 1));
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const getDayName = (date: Date): string => {
  const dayNames = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
  return dayNames[date.getDay()];
};

export const formatConflictDate = (dateStr: string): string => {
  return DateTime.fromISO(dateStr).toFormat('dd/MM/yyyy');
};
